<template>
<div class="chapter">
<div class="inner_page">
<p class="bodytext-center" id="dedi" style="margin-top: 30%;"><em>This book is lovingly dedicated to the Nazarene.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006dedication.vue?a57b2d10